import { ReactNode } from "react"
import { Block, LabelMedium, Radio, useStyletron } from "@mezo-org/mezo-clay"

type BorrowStrategyItemProps = {
  title: string
  description: ReactNode
  status?: ReactNode
  isDisabled?: boolean
  isChecked?: boolean
  onChange: () => void
}

export default function BorrowStrategyItem({
  title,
  description,
  status,
  isChecked = false,
  isDisabled = false,
  onChange,
}: BorrowStrategyItemProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "flex",
        padding: theme.sizing.scale600,
        paddingRight: theme.sizing.scale800,
        background: theme.colors.backgroundSecondary,
        borderRadius: theme.borders.radius300,
        marginBottom: theme.sizing.scale300,
      })}
    >
      <Block
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale100,
          flexGrow: 1,
        })}
      >
        <LabelMedium>{title}</LabelMedium>
        {description}
        {status && (
          <Block
            className={css({
              display: "flex",
              gap: theme.sizing.scale100,
              alignItems: "center",
              marginTop: theme.sizing.scale0,
            })}
          >
            {status}
          </Block>
        )}
      </Block>
      <Radio
        disabled={isDisabled}
        checked={isChecked}
        onChange={onChange}
        overrides={{
          RadioMarkInner: {
            style: { backgroundColor: theme.colors.backgroundSecondary },
          },
        }}
      />
    </Block>
  )
}
